import { useEffect } from "react";
import "./styles.css";
import { useUID } from "../../context/UIDContext";
import { useAmplitude } from "../../context/AmplitudeContext";
import { IoChevronBackOutline } from "react-icons/io5";
import { Trans, useTranslation } from "react-i18next";

export const LandingPage = ({ onContinue, onBackClick }) => {
  const { t } = useTranslation("recommendation");
  const trackEvent = useAmplitude();
  const { uid } = useUID();

  useEffect(() => {
    trackEvent("webapp_user_visited_products_landing_page", uid);
  }, [uid, trackEvent]);

  return (
    <div className="product-landing-page">
      <img
        src="product-landing.png"
        className="landing-page-image"
        alt="Sprechen"
      />
      <div className="landing-page-background-overlay" />
      <div className="product-page-nav">
        <div className="products-back-button-wrapper">
          <IoChevronBackOutline
            className="back-icon"
            onClick={() => {
              trackEvent("webapp_user_back_button_products_landing_page", uid);
              onBackClick();
            }}
          />
        </div>
      </div>
      <div className="landing-page-title-container">
        <h4 className="landing-page-title" style={{ paddingBottom: "0.75rem" }}>
          <Trans
            i18nKey="landingPage.title"
            ns="recommendation"
            components={{
              italic: <span style={{ fontStyle: "italic" }} />,
            }}
          />
        </h4>
      </div>
      <div className="landing-page-button-container">
        <button
          className="landing-page-button"
          onClick={() => {
            trackEvent(
              "webapp_user_continue_button_products_landing_page",
              uid,
            );
            onContinue();
          }}
        >
          {t("landingPage.cta")}
        </button>
      </div>
    </div>
  );
};
